export interface ScheduleServiceGetAllParams {
    page?: number;
    per_page?: number;
    order_by?: string;
    is_active?: boolean;
    search?: string;
}
